/** Product copy in one place, so the demo can be re-labelled without touching components. */
export const brand = {
  name: "passio",
  product: "API demo",
  tagline: "Turn food into action.",
  intro:
    "Search Passio's food database, scan barcodes, recognise meal photos and turn free text into structured, meal-aware nutrition. Every call shows its headers, usage and raw JSON.",
  /** Passio's GitBook; page paths in lib/docs.ts. */
  docsUrl: "https://passio.gitbook.io/nutrition-ai",
  supportEmail: "support@passiolife.com",
  /** Where demo users sign up for a plan and get production keys. */
  accountsUrl: "https://accounts.passiolife.com",
} as const;
